import React from "react";
import { Check, X } from "lucide-react";

const rows = [
  { label: "Speed", old: "Slow — multi-step measuring", neu: "Fast — single-tool setup" },
  { label: "Accuracy", old: "Variable — depends on the marker", neu: "Precision — repeatable to ±0.5mm" },
  { label: "Repeatability", old: "Inconsistent panel-to-panel", neu: "Identical across every panel" },
  { label: "Ease of Use", old: "Tape + pencil + square + brain", neu: "One adjustable trade-grade tool" },
  { label: "Finish Quality", old: "Acceptable", neu: "Professional, contractor-grade" },
  { label: "Rework Risk", old: "High — costly mistakes", neu: "Minimised by design" },
];

export const Comparison = () => {
  return (
    <section
      data-testid="comparison-table"
      className="relative py-24 md:py-36 border-t border-[#27272A] bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="label-eyebrow">05 / Before vs After</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter mt-4">
            The old way vs.{" "}
            <span className="text-[#FF6B00]">the AdjustaGland way</span>
          </h2>
          <p className="mt-5 text-[#A1A1AA] text-base md:text-lg">
            A side-by-side look at the workflow upgrade your team can expect on
            day one.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-[#27272A] border border-[#27272A] rounded-sm overflow-hidden">
          {/* Old way */}
          <div
            data-testid="comparison-old"
            className="bg-[#0A0A0A] p-8 md:p-10"
          >
            <div className="flex items-center justify-between mb-8">
              <div>
                <div className="font-mono-spec text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA]">
                  Method A
                </div>
                <h3 className="font-display text-2xl md:text-3xl mt-1">
                  Traditional Marking
                </h3>
              </div>
              <span className="w-12 h-12 grid place-items-center bg-[#1F1F1F] border border-[#27272A] rounded-sm">
                <X className="w-5 h-5 text-[#A1A1AA]" strokeWidth={2.5} />
              </span>
            </div>
            <ul className="space-y-4">
              {rows.map((r) => (
                <li
                  key={r.label}
                  className="flex items-start justify-between gap-4 pb-4 border-b border-[#27272A] last:border-b-0"
                >
                  <span className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-[#A1A1AA] pt-0.5 min-w-[110px]">
                    {r.label}
                  </span>
                  <span className="text-[#D4D4D8] text-sm md:text-[15px] text-right max-w-xs">
                    {r.old}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* New way */}
          <div
            data-testid="comparison-new"
            className="bg-gradient-to-br from-[#141414] to-[#0A0A0A] p-8 md:p-10 relative"
          >
            <div className="absolute top-0 right-0 px-3 py-1.5 bg-[#FF6B00] text-black font-mono-spec text-[10px] uppercase tracking-[0.22em] font-bold">
              Recommended
            </div>
            <div className="flex items-center justify-between mb-8">
              <div>
                <div className="font-mono-spec text-[10px] uppercase tracking-[0.25em] text-[#FF6B00]">
                  Method B
                </div>
                <h3 className="font-display text-2xl md:text-3xl mt-1">
                  AdjustaGland<span className="text-[#FF6B00]">™</span> PRO
                </h3>
              </div>
              <span className="w-12 h-12 grid place-items-center bg-[#FF6B00] rounded-sm metal-edge">
                <Check className="w-5 h-5 text-black" strokeWidth={3} />
              </span>
            </div>
            <ul className="space-y-4">
              {rows.map((r) => (
                <li
                  key={r.label}
                  className="flex items-start justify-between gap-4 pb-4 border-b border-[#27272A] last:border-b-0"
                >
                  <span className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-[#A1A1AA] pt-0.5 min-w-[110px]">
                    {r.label}
                  </span>
                  <span className="text-white text-sm md:text-[15px] text-right max-w-xs font-medium">
                    {r.neu}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
